import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CompaniesService } from 'app/services/company/companies.service';
import { Company } from '../../../models/company.model';

@Component({
  selector: 'app-company-form',
  templateUrl: 'companyForm.component.html',
  styles: ['label.required:after {top: 0}']
})

export class CompanyFormComponent implements OnInit {
  @Output() companyAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() companyUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxCompany: Company;
  addEditForm: FormGroup;

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private compService: CompaniesService,
    private fb: FormBuilder) {
  }

  ngOnInit() {

    this.compService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditForm = this.fb.group({
      'name': new FormControl(this.dialogBoxCompany.name),
      'host_code': new FormControl(this.dialogBoxCompany.host_code)
    });

  }

  saveOrUpdate(dialogBox: any): void {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxCompany, this.addEditForm.value);
    if (newData.id == null) {
      this.companyAdded.emit(newData);
    } else {
      this.companyUpdated.emit(newData);
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/company/companyForm.component.ts